<template>
<div>
  <div class="text-center">
      <!-- <h2 class="my-4"> some text here add some text what to do here </h2> -->
  </div>
  <v-row class="appointment-maker">

    <v-col cols="12" md="8" class="appointment-maker__datepicker">
      <v-date-picker class="appointment-maker__datepickerSelf" :min="minimumDate" :reactive="true" elevation="8" full-width :allowed-dates="allowedDates" v-model="selectedDate" ref="datePicker" :picker-date.sync="pickerDate"></v-date-picker>
    </v-col>
    <v-col cols="12" md="4" class="appointment-maker__slots">
      <h3 class="mb-4 appointment-maker__timeSlotAvailable" v-if="currentDateSlots.length">Available Timeslots</h3>
      <p class="mb-4 appointment-maker__timeSlot" v-else>Please select a date to see available timeslots</p>
      <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="success"></v-progress-linear>

      <v-virtual-scroll v-if="currentDateSlots.length" itemHeight="120" :items="currentDateSlots" :height="availableHeightCalc">
        <template class="appoitment-maker__tem" v-slot="{ item }">
          <v-card @click="selectTimeSlot(item)" hover class="appointmet-maker__slot mb-4 mx-4" :dark="item.selected">
            <v-card-title>{{ item.timestamp | moment("h:mm a") }} - {{ item.timestamp_end | moment("h:mm a") }}</v-card-title>
            <v-card-text>EST Timezone</v-card-text>
          </v-card>
        </template>
      </v-virtual-scroll>
      <div class="mt-4 px-4 mb-8" v-if="currentDateSlots.length">
        <v-btn class="myPaBoxButton v-btn v-btn--block v-btn--depressed theme--light v-size--default info" @click="confirmSlot" v-if="selectedTimeSlot && selectedTimeSlot.timestamp && selectedTimeSlot.timestamp_end">Confirm</v-btn>
      </div>
    </v-col>
  </v-row>
</div>
</template>
<script>
import ServiceAPI from '@/lib/serviceApi'
import moment from 'moment'
export default {
  props: [
    'serviceId'
  ],
  data () {
    return {
      availableSlots: [],
      pickerDate: null,
      selectedDate: null,
      minimumDate: moment().subtract(1, 'day').toISOString(),
      selectedTimeSlot: null,
      loadedMonths: [],
      loading: false,
      availableHeight: 0
    }
  },
  watch: {
    pickerDate () {
      this.$nextTick(() => {
        this.selectedDate = null
        this.fetchSlots()
      })
    }
  },
  computed: {
    currentDateRange () {
      const currentDate = this.pickerDate ? moment(this.pickerDate) : moment()
      const lastDate = this.pickerDate ? moment(this.pickerDate) : moment()
      return {
        from: currentDate.toISOString(),
        to: lastDate.endOf('month').toISOString()
      }
    },
    currentDateSlots () {
      if (this.selectedDate) {
        return this.availableSlots.filter(({ slot }) => {
          return moment(slot.timestamp).isSame(this.selectedDate, 'day')
        }).map(({ slot }) => {
          if (this.selectedTimeSlot && slot.timestamp === this.selectedTimeSlot.timestamp && slot.timestamp_end === this.selectedTimeSlot.timestamp_end) {
            return {
              ...slot,
              selected: true
            }
          }
          return slot
        })
      }
      return []
    },
    availableHeightCalc () {
      return window.innerHeight - 300 > 400 ? window.innerHeight - 300 : 400
    }
  },
  methods: {
    async fetchSlots () {
      if (this.loadedMonths.includes(this.currentDateRange.from)) return this.availableSlots
      this.loading = true
      const { data } = await ServiceAPI.get('appointments/available-slots', {
        params: {
          ...this.currentDateRange,
          serviceID: this.serviceId ? this.serviceId : 14644
        }
      })
      this.loading = false
      this.loadedMonths.push(this.currentDateRange.from)
      this.availableSlots = this.availableSlots.concat(data)
      if (this.availableSlots.length) {
        this.selectedDate = this.availableSlots[0].timestamp
      }
      return this.availableSlots
    },
    allowedDates (val) {
      return this.availableSlots.find(({ slot }) => {
        return moment(slot.timestamp).isSame(val, 'day')
      })
    },
    selectTimeSlot (item) {
      this.selectedTimeSlot = item
    },
    confirmSlot () {
      this.$emit('select', this.selectedTimeSlot)
    }
  }
}
</script>
<style>
  .appointment-maker {
    min-height: 600px;
  }
  .appointment-maker__datepicker .v-btn--active {
    background-color: #1976d2 !important;
  }

  .appointment-maker__slots {
    position: relative;
  }

  .appoitment-maker__tem {
    background-color: #ccc;
  }
  .appointment-maker__timeSlot {
    font-size: 20px;
    text-align: center;
    margin-top: 150px;
  }

  .appointment-maker__timeSlotAvailable {
    font-size: 20px;
    text-align: center;

  }
  .appointment-maker__datepickerSelf,
  .appointment-maker__datepickerSelf .v-picker__body>div,
  .appointment-maker__datepickerSelf .v-date-picker-table,
  .appointment-maker__datepickerSelf .v-date-picker-table table{
    /* height: 100%; */
  }
  .appointment-maker__datepickerSelf .v-picker__body>div {

  }

  .v-application .info.myPaBoxButton {
      background-color: #191340!important;
      border-color: #191340!important;

  }
  .v-application .primary {
      background-color: #191340!important;
      border-color: #191340!important;
  }
  .appointment-maker__datepicker .v-btn--active {
      background-color: #191340!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Services/AppointmentPicker.vue